import { Component } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-privacy',
  styleUrl: './privacy.scss',
  templateUrl: './privacy.html',
})
export class Privacy {
}
